/**
 * Get the URL parameter value by name
 * @param {name} string name of the parameter
 * @param {search} string custom params
 * @returns {string}
 */
const getQueryParam = (name, search) => {
    const params = new URLSearchParams(search || window.location.search);
    const result = params.get(name);
    return result ? decodeURIComponent(result) : result;
};
export default getQueryParam;
